(function () {
	'use strict';

	angular.module('mx.components').component('mxWorkspaceCommonSearchPanel', {
		bindings: {
			preprocessor: '=',
			parameters: '=',
		},
		controller: MxWorkspaceCommonSearchPanelCtrl,
		controllerAs: 'vm',
		templateUrl: 'mx-datasource-search-panel/mx-datasource-search-panel.html',
	});

	MxWorkspaceCommonSearchPanelCtrl.$inject = ['$scope'];

	function MxWorkspaceCommonSearchPanelCtrl($scope) {
		var vm = this;

		vm.$onInit = function () {
			vm.searchText = '';
			vm.search = search;
			vm.isDisabled = false;
		};

		$scope.$watch('vm.preprocessor.loading', function (value) {
			if (vm.preprocessor) {
				vm.isDisabled = value;
			}
		});

		function search(searchText) {
			vm.searchText = searchText;
			if (vm.preprocessor) {
				vm.preprocessor.searchText = searchText;
				vm.preprocessor.callChanged();
			}
		}

		return vm;
	}
})();
